import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropeListData } from "Pages/AutoEuropeTool/Page/@signals"

export default function useAutoEuropeStatus(id, name) {
	const { showToast } = useToast()

	const handleStatus = useCallback((newStatus) => {
		autoEuropeListData.value = autoEuropeListData.value.map(item =>
			item.id === id ? { ...item, enabled: newStatus } : item
		)
		postSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/${newStatus ? 'enable' : 'disable'}`, { id })
			.catch(() => {
				showToast.error(`Error changing the status of '${name}'.`)
				autoEuropeListData.value = autoEuropeListData.value.map(item =>
					item.id === id ? { ...item, enabled: !newStatus } : item
				)
			})
	}, [id])

	return { handleStatus }
}